<template>
  <div class="wdx login login-container text-center" v-if="!tokenChecking">
    <div class="row login-block">
      <div class="col">
        <h2 class="text-primary">Log in</h2>
      </div>
    </div>

    <div class="row login-block">
      <div class="w-100 d-flex justify-content-center">
        <div class="w-100 mt-1 text-secondary text-center font-18">
          Already have an username?
          <router-link to="/signin">Log in using username</router-link>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center mw-100">
      <form class="px-4 mw-100" @submit="formSubmit">
        <div class="login-block form-start-block">
          <div class="row">
            <div class="col text-left font-14">
              Your User Name or Email Address
            </div>
          </div>
          <div class="row">
            <div class="col">
              <input
                type="text"
                name="username"
                class="form-control"
                v-model="email"
                :class="{ error: $v.email.$error }"
                :disabled="loginLoading"
                data-testid="inputUsername"
              />
              <div class="text-left text-secondary font-12">
                If you don’t have username, use
                <strong>your company email</strong> to log in and enroll
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3" v-if="notification">
          <div class="col">
            <div class="notification p-3 text-center">
              {{ notification }}
            </div>
          </div>
        </div>

        <div class="row form-button">
          <div class="col" v-if="!showSendEmail">
            <button
              name="sign-on"
              type="submit"
              class="btn btn-info btn-sm px-4"
              :disabled="loginLoading"
              data-testid="buttonLogin"
            >
              <div
                class="
                  spinner-border spinner-border-sm
                  text-primary
                  login-spinner
                "
                role="status"
                v-if="loginLoading"
              >
                <span class="sr-only">Loading...</span>
              </div>
              Login
            </button>
          </div>

          <div class="col" v-if="showSendEmail">
            <button type="submit" class="btn btn-info btn-sm px-4 mr-2">
              <img
                src="@/assets/imgs/send_me_login_message_icon.svg"
                class="mr-2"
              />
              Send me Login Link
            </button>
            <button
              type="button"
              class="btn btn-info btn-sm px-4"
              @click="backToInputEmail"
            >
              Back
            </button>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <div class="p-3 text-center text-secondary">
              If you are experiencing a problem with new login, try to use
              <a href="/login.aspx">a previous log in page</a>.
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div v-else class="d-flex justify-content-center align-items-center huge-spinner-container">
    <div
      class="
        spinner-border
        spinner-huge
        text-primary
        login-spinner
      "
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</template>

<script>
import WdxBaseComponentMixin from '../../common/mixins/wdxBaseComponent';
import { required } from 'vuelidate/lib/validators';
import {
  MUTATION_REGISTRATION_EMAIL,
  MUTATION_REGISTRATION_FULLNAME,
  MUTATION_REGISTRATION_USERID
} from '../constants';
import loginComponentMixin from './loginComponentMixin';

export default {
  mixins: [WdxBaseComponentMixin, loginComponentMixin],
  data() {
    return {
      email: '',
      notification: null,
      showSendEmail: false,
      loginLoading: false,
      tokenChecking: true,
    };
  },
  validations: {
    email: {
      required
    }
  },
  computed: {
    registrationEmail() {
      return this.$store.state.registrationEmail;
    }
  },
  watch: {
    $route() {
      this.checkToken(this.$route.query.ltoken);
    }
  },
  mounted: function () {
    this.checkToken(this.$route.query.ltoken);
  },
  methods: {
    formSubmit(e) {
      e.preventDefault();

      this.notification = null;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }

      if (!this.showSendEmail) {
        this.checkEmail();
      } else {
        this.sendEmail();
      }
    },

    checkEmail() {
      if (this.$commonService.isEmptyOrWhitespaceString(this.email)) return;

      this.$store.commit(MUTATION_REGISTRATION_EMAIL, null);

      this.loginLoading = true;
      this.$userService
        .checkUserEmail(this.email)
        .then((response) => {
          this.loginLoading = false;
          if (response.data) {
            const res = response.data;
            if (res.Exists) {
              if (res.SingleSignOnAllowed) {
                this.$store.commit(MUTATION_REGISTRATION_EMAIL, res.Email);
                this.$store.commit(MUTATION_REGISTRATION_USERID, res.UserId);
                this.$store.commit(
                  MUTATION_REGISTRATION_FULLNAME,
                  res.FirstName + ' ' + res.LastName
                );
                this.$router.push({ name: 'signin' });
              } else if (res.LoginAllowed) {
                this.$store.commit(MUTATION_REGISTRATION_EMAIL, this.email);
                this.$router.push({ name: 'signin'});
              } else {
                if (res.IsCompletedRegistration)
                  this.notification = 'User is disabled';
                else {
                  this.$store.commit(MUTATION_REGISTRATION_EMAIL, this.email);
                  this.$router.push({
                    name: 'emailSent',
                    query: { registered: 'true' }
                  });
                }
              }
            } else {
              if (res.RegistrationAllowed) {
                this.notification =
                  "You don't have password set. Please login using Email Link below.";
                this.$store.commit(MUTATION_REGISTRATION_EMAIL, this.email);
                this.showSendEmail = true;
              } else {
                this.notification =
                  'Cannot find organization associated with specified domain. Please use username and password to login.';
              }
            }
          }
        })
        .catch((error) => {
          this.loginLoading = false;
          this.handleHttpError(error, true);
        });
    },

    sendEmail() {
      this.$userService
        .sendRegistrationEmail(this.registrationEmail)
        .then((response) => {
          const data = response.data;
          if (data) {
            if (data.Result) {
              this.$router.push({ name: 'emailSent' });
            } else {
              this.showErrorByRegistrationResult(data.CheckResult);
            }
          }
        })
        .catch((error) => {
          this.handleHttpError(error, true);
        });
    },

    backToInputEmail(e) {
      e.preventDefault();
      this.showSendEmail = false;
    },

    showErrorByRegistrationResult(res) {
      if (res.Exists) {
        this.notification = 'User with same email address already registered';
      } else if (!res.RegistrationAllowed) {
        this.notification =
          'Cannot find organization associated with specified domain. Please use username and password to login';
      }
    },

    checkToken(tok) {
      if (!tok) {
        this.tokenChecking = false;
        return;
      }
      this.tokenChecking = true;
      this.showLoading();
      this.$userService
        .checkLoginToken(tok)
        .then((response) => {
          this.hideLoading();
          const res = response.data;
          if (res.Error) {
            this.notification = res.Error;
          } else if (res.CookieValue) {
            const expDate = new Date(res.CookieExpiration);
            document.cookie = `${res.CookieName}=${res.CookieValue}; path=${
              res.CookiePath
            }; samesite=${
              res.CookieSameSite
            }; expires=${expDate.toUTCString()}; secure=false;`;
            const redirectUrl = res.RedirectUrl;
            const defaultUrl = this.getRedirectUrl(res.DefaultUrl);
            if(redirectUrl) {
              location = redirectUrl;
            }
            else if (res.RegistrationInformationRequired) {
              this.$router.push({ name: 'registration' });
            } else {
              location = defaultUrl;
            }
          } else {
            this.notification = 'There is an error.';
          }
        })
        .catch((error) => {
          this.handleHttpError(error, true);
        }).finalize(() => {
          this.tokenChecking = false;
        });
    }
  }
};
</script>

<style scoped>
  .spinner-huge {
    width: 5rem;
    height: 5rem;
  }
  .huge-spinner-container {
    display: none;
    height: 100vh;
    width: 100vw;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    background: rgba( 255, 255, 255);
  }
</style>
